import React, { useEffect } from "react";
import Filters from "./Filters";
import ListTemplate, { listTemplateQueryKey } from "components/ListTemplate";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { cardLayout } from "./cardLayout";
import { useQueryClient } from "@tanstack/react-query";
import { useLoaderData } from "react-router";
import FlightApp from "flights/new/app";
import TrainModal from "train/TrainModal";

declare const UI: any;

const GroundTransportListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.GroundTransportListFrontModel>();

  useEffect(() => {
    // TODO: This is needed here because we're calling Ground Transport which uses the old UI.
    //  Without this, some form elements are not initialized properly.
    UI.onStartUp({
      isConfirmationPage: false,
      pageIsPostBack: false
    });
  }, []);

  const queryClient = useQueryClient();

  const onShowChange = () => {
    queryClient.invalidateQueries([listTemplateQueryKey]);
  }

  return <>
    <FlightApp />
    <TrainModal />
    <ListTemplate
      title={RESX.GroundTransport.GroundTransports}
      filterSet="groundTransport_List"
      defaultFilters={viewModel.defaultFilters}
      initialInstruction={viewModel.initialInstruction}
      fetchFunction={window.CoreApi.GroundTransport.Paginated}
      getId={item => item.id}
      layout={cardLayout(onShowChange)}
      filters={<Filters />}
      functions={{
        mapFilterValuesToInstruction,
        mapResponseToFilterValues
      }}
    />
  </>
};

export default GroundTransportListApp;
